// extracted by mini-css-extract-plugin
module.exports = {"GeneralContainer__Theme":"Themes_GeneralContainer__Theme__l6H6Z","apply-global-style":"Themes_apply-global-style__0n11l","applyGlobalStyle":"Themes_applyGlobalStyle__f1LBp"};